export class UfficioVO {
  codice: string;
  nome: string;
  responsabile: string;
  output: string;
}
